export default (object, keys) => Object.keys(object || {}).reduce((target, key) => {
  if (keys.indexOf(key) < 0) {
    return { ...target, [key]: object[key] };
  }
  return target;
}, {});
